var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getToken, Loader, request } from "./utils";
let stripe;
if (window.Stripe !== undefined) {
    stripe = Stripe(stripePublicKey);
}
const usp = new URLSearchParams(window.location.search);
const lang = usp.get("lang");
class StripeUtils {
    static goToCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            Loader.show();
            const token = getToken();
            const res = yield request({
                authToken: token,
                method: "POST",
                path: "stripe/checkout",
                payload: { lang },
            });
            yield this.redirectToCheckout(res.stripeSessionId);
        });
    }
    static redirectToCheckout(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield stripe.redirectToCheckout({ sessionId });
        });
    }
    static handleRequiresAction(appUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const { clientSecret } = document.getElementById("requires-action").dataset;
            Loader.show();
            const result = yield stripe.confirmCardPayment(clientSecret);
            if (result.error) {
                alert(result.error.message);
                window.location.reload();
            }
            else {
                window.location.href = `${window.location.origin}/success?${appUrl ? `appUrl=${appUrl}` : ""}`;
            }
        });
    }
}
export default StripeUtils;
